<div class="mb-27 mct-flex mct-row mct-justify-between mct-items-center">
  <button pButton class="atlas-btn atlas-btn-secondary tall" type="button"
    title="{{ 'profiles.relationships.back-to-profile' | translate | uppercase }}"
    [routerLink]="['/profile', profileId]" [icon]="'large-icon pi pi-angle-left'"
    [label]="'profiles.transactions.back-to-profile' | translate | uppercase">
  </button>
  <button pButton type="button" class="atlas-btn atlas-btn-primary tall" [disabled]="isReadOnly"
    (click)="editDialog.showModal()" [label]="'profiles.web-content.new-web-content' | translate | uppercase"></button>
</div>

<span class="title-header mb-27">{{ 'profiles.web-content.header' | translate | titlecase }}</span>

<wl-busy *ngIf="!profile" [show]="!profile"></wl-busy>
<div *ngIf="profile" class="mb-29 mct-flex mct-row mct-justify-start mct-items-center mct-gap-13">
  <wl-profile-type-icon [isMember]="profile.Member" [isOrg]="profile.OrgInd" [profileId]="profile.OrgInd"
    [memberTypeIconColor]="profile.MemberTypeIconColor"
    [styleOverrides]="{ 'max-width': '34px', 'max-height': '34px' }"></wl-profile-type-icon>
  <span>
    <strong>{{ profile.ReportName }}</strong> ({{ profile.ProfileId }})
  </span>
</div>

<wl-web-content-edit-dialog #editDialog [profileId]="profileId"
  (webContentSaved)="webContentGrid.search()"></wl-web-content-edit-dialog>

<wl-web-content-search-grid #webContentGrid [searchParams]="webContentSearchParams" [isReadOnly]="isReadOnly"
  [includeProfile]="false" [includeHeader]="false"></wl-web-content-search-grid>
